"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sizesMap = void 0;
var ModalProps_1 = require("./ModalProps");
var tabletStyles = require("./Modal.tablet.css");
var desktopStyles = require("./Modal.desktop.css");
exports.sizesMap = new Map([
    [ModalProps_1.ModalSizes.SMALL, tabletStyles.modalSm],
    [ModalProps_1.ModalSizes.MEDIUM, ''],
    [ModalProps_1.ModalSizes.LARGE, desktopStyles.modalLg],
    [ModalProps_1.ModalSizes.FULL_SCREEN, desktopStyles.modalFullscreen],
]);
//# sourceMappingURL=ModalStylesMaps.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Modal/ModalStylesMaps.js
// module id = 1103
// module chunks = 8